<template>
  <div>
    <b-modal ref="devolver-despesa"
        size="md"
        centered
        id="add-brower-modal"
        title="Devolução da Despesa"
        :hide-footer="true"
        :clickToClose="false"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        :hide-header-close="true">
      <div>
        <!-- <div class="conteiner"><i class="fa fa-window-close icone"></i></div> -->
        <div class="label conteiner">Informe o motivo da devolução!</div>
        <div class="caxa-texto conteiner">
          <textarea class="form-control mt-3" rows="10" cols="175" v-model="motivo"></textarea>
        </div>
      </div>
      <div class="conteiner pt-3">
        <button @click="voltar" class="button-cancel">VOLTAR</button>
        <button @click="verificaMetodo" class="button-save">SALVAR</button>
      </div>
    </b-modal>
    <b-modal ref="modal-EscolhaReprova"
        size="md"
        centered
        id="add-brower-modal"
        title="Reprovação"
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        @close="onCloseChoice">
      <div class="icone-reprova">
        <i class="fas fa-thumbs-down"></i>
      </div>
      <div>
        <div class="labelmodal conteiner">Escolha o tipo de reprovação!</div>
      </div>
      <div class="d-flex justify-content-center pt-3">
        <button @click="modalDevolucaoDespesaDevolver" class="button-info m-3">DEVOLUÇÃO</button>
        <button @click="modalDevolucaoDespesaDefinitivo" class="button-reprova m-3">DEFINITIVA</button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'BoardTrevelExpenseEmployee',
  // components: {Search, Details},
  mixins: [ActionsForm],
  props: {
    lstdespesa: {
      type: Array,
      default: () => []
    },
    modalReturn: {
      type: Boolean,
      default: false
    },
    viagemMetodo: {
      type: Number,
      default: null
    },
    viagemMetodoUnico: {
      type: Number,
      default: 0
    },
    detalheDespesa: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      despesas: [],
      motivo: null,
      load: false,
      definitivo: null
    }
  },
  computed: {
  },
  mounted () {
  },
  watch: {
    modalReturn () {
      this.modal()
    },
    lstdespesa (value) {
      this.despesas = value
    }
  },
  methods: {
    modal () {
      // if (this.modalReturn) {
      this.$refs['modal-EscolhaReprova'].show()
      // } else this.voltar()
    },
    voltar () {
      this.motivo = null
      this.despesas = []
      this.definitivo = null
      this.$refs['devolver-despesa'].hide()
      this.$refs['modal-EscolhaReprova'].hide()
    },
    onCloseChoice () {
      if (this.definitivo == null) {
        this.voltar()
      } else {
        this.$refs['devolver-despesa'].show()
      }
    },
    verificaMetodo () {
      if (this.viagemMetodo != null) {
        this.disaApprove()
      }
      if (this.viagemMetodoUnico != null) {
        this.DisaApprovedDespesaByid()
      }
    },
    disaApprove () {
      if (this.despesas) {
        TravelExpenseRepository.DisaApproveDespesasViagemContraladoria({motivoRecusa: this.motivo, despesaviagemids: this.despesas, reprovacaoDefinitiva: this.definitivo})
          .then((Response) => {
            loading.pop()
            this.$emit('Load', !this.load)
            this.$refs['devolver-despesa'].hide()
            toast.success('Devoluções realizadas com sucesso')
          })
          .catch((Error) => {
            toast.error('Ocorreu um erro')
          })
      }
    },
    DisaApprovedDespesaByid () {
      loading.push()
      TravelExpenseRepository.DisaApprovedDespesaByid({motivoRecusa: this.motivo, despesaviagemid: this.detalheDespesa, reprovacaoDefinitiva: this.definitivo})
        .then((Response) => {
          toast.success('Despesa Reprovada com sucesso')
          this.$refs['devolver-despesa'].hide()
          this.$emit('Load', !this.load)
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
          toast.warning('Ocorreu um erro')
        })
    },
    modalDevolucaoDespesaDevolver () {
      this.definitivo = false
      this.$refs['modal-EscolhaReprova'].hide()
      this.$refs['devolver-despesa'].show()
    },
    modalDevolucaoDespesaDefinitivo () {
      this.definitivo = true
      this.$refs['modal-EscolhaReprova'].hide()
      this.$refs['devolver-despesa'].show()
    }
  }

}
</script>
<style scoped>
.conteiner{
    display: flex;
    gap: 1rem;
    justify-content: center;
}
.icone{
    font-size: 50px;
    color: rgb(167, 30, 30);
}
.label{
    padding-top: 0.5rem;
    font: normal normal 600 15px/20px Segoe UI;
    font-size: 20px;
    font-weight: bold;
}

.button-cancel{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(167, 30, 30);
}
.button-save {
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(4, 90, 30);
}
.button-reprova{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(168 28 6);
}
.button-info{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(208 195 43);
}
.labelmodal{
    padding: 1rem;
    font: normal normal 600 15px/20px Segoe UI;
    font-size: 20px;
    font-weight: bold;
  }
  .icone-reprova{
    display: flex;
    font-size: 44px;
    padding: 10px;
    justify-content: center;
  }

</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/trevelexpenseemployee/components/RefuseModalReturnTrip/RefuseModalReturnTrip.vue